import { render, staticRenderFns } from "./FieldTextarea.vue?vue&type=template&id=9b807fca&scoped=true&"
import script from "./FieldTextarea.vue?vue&type=script&lang=js&"
export * from "./FieldTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FieldTextarea.vue?vue&type=style&index=0&id=9b807fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b807fca",
  null
  
)

export default component.exports